// ** MUI Imports
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

// ** Footer Content Component
import FooterContent from './FooterContent'

const Footer = props => {
  // ** Props
  const { settings, footerStyles, footerContent: userFooterContent } = props

  // ** Hook
  const theme = useTheme()

  // ** Vars
  const { skin, footer, layout, contentWidth } = settings

  if (footer === 'hidden') {
    return null
  }

  return (
    <Box
      component='footer'
      className='layout-footer'
      sx={{
        width: '100%',
          background: `
    linear-gradient(-60deg, #b4b8d5 0%, #ffffff calc(100% - 350px), transparent calc(100% - 549px)) no-repeat,
    linear-gradient(-60deg, #ECF0F1 0%, #ECF0F1 calc(100% - 150px), transparent calc(100% - 170px)) no-repeat,
    #1B205C
  `,
  backgroundSize: '100% 100%',
  backgroundPosition: 'right top',
  '@media (max-width: 1200px)': {
    background: `
      linear-gradient(-60deg, #b4b8d5 0%, #ffffff calc(100% - 400px), transparent calc(100% - 399px)) no-repeat,
      linear-gradient(-60deg, #ECF0F1 0%, #ECF0F1 calc(100% - 350px), transparent calc(100% - 349px)) no-repeat,
      #1B205C
    `
  },
  '@media (max-width: 768px)': {
    background: `
      linear-gradient(-60deg, #b4b8d5 0%, #ffffff calc(100% - 200px), transparent calc(100% - 199px)) no-repeat,
      linear-gradient(-60deg, #ECF0F1 0%, #ECF0F1 calc(100% - 150px), transparent calc(100% - 149px)) no-repeat,
      #1B205C
    `
  },
 
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...(footer === 'fixed' && {
          bottom: 0,
          position: 'sticky',
          ...(layout === 'vertical'
            ? { px: [4, 6] }
            : {
                backgroundColor: 'background.paper',
                ...(skin === 'bordered' ? { borderTop: `1px solid ${theme.palette.divider}` } : { boxShadow: 6 })
              })
        }),
        ...footerStyles
      }}
    >
      <Box
        className='footer-content-container'
        sx={{
          width: '100%',
          py: theme.spacing(footer === 'fixed' && skin === 'bordered' ? 3 : 3),
          ...(contentWidth === 'boxed' && { '@media (min-width:1440px)': { maxWidth: 1440 } }),
          ...(layout === 'vertical' && {
            borderTopLeftRadius: 14,
            borderTopRightRadius: 14,
            ...(footer === 'fixed' && { backgroundColor: 'background.paper' })
          }),
          ...(footer === 'fixed'
            ? {
                px: [5, 6],
                ...(contentWidth === 'boxed' &&
                  layout === 'vertical' && {
                    '@media (min-width:1440px)': { maxWidth: `calc(1440px - ${theme.spacing(6)} * 2)` }
                  }),
                ...(layout === 'vertical' && {
                  ...(skin === 'bordered'
                    ? { border: `1px solid ${theme.palette.divider}`, borderBottomWidth: 0 }
                    : { boxShadow: 6 })
                })
              }
            : { px: [4, 6] }),
          // paddingBottom: 'none'
        }}
      >
        {userFooterContent ? userFooterContent(props) : <FooterContent />}
      </Box>
    </Box>
  )
}

export default Footer
